import {
  cmsDocumentFileDownload,
  dmDocumentFileDownload,
  rssXmlDownload,
} from '../../api/api';
import { React, useState, useEffect } from 'react';
import { LoadingSpinner } from '../../components/loading-spinner/loading-spinner';
import './download-page.scss';

export const DownloadPage = ({ ...props }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const callDownload = async () => {
    try {
      const params = new URLSearchParams(window.location.search.substring(1));
      const downloadType = params.get('downloadType');
      if (downloadType && downloadType.toLowerCase() === 'dm') {
        const feedId = params.get('feedId');
        const docTag = params.get('docTag');
        const componentType = params.get('componentType');
        const fileName = params.get('fileName');
        const newParams = `feedId=${feedId}&docTag=${docTag}&componentType=${componentType}&fileName=${fileName}`;
        return await dmDocumentFileDownload(fileName, null, newParams);
      } else if (downloadType && downloadType.toLowerCase() === 'cms') {
        const cmsId = params.get('cmsId');
        const fileName = params.get('fileName');
        const componentType = params.get('componentType');
        const newParams = `cmsId=${cmsId}&fileName=${fileName}&componentType=${componentType}`;
        return await cmsDocumentFileDownload(fileName, null, newParams);
      } else if (downloadType && downloadType.toLowerCase() === 'rss') {
        const rssId = params.get('Id');
        //const isArchived = params.get('archive');
        const baseUrl = `${window.location.origin}/sigmaxmtf`;
        console.log('RSS rssId: ', rssId);
        console.log('RSS baseUrl: ', baseUrl);
        const newParams = `baseUrl=${baseUrl}&isArchived=0`; // IsArchived is ignored in the old production.
        return await rssXmlDownload(rssId, newParams);
      }
    } catch (ex) {
      setIsError(true);
      setErrorMessage(ex.message);
    }
  };

  useEffect(() => {
    if (isLoading) {
      callDownload();
    }
  }, [isLoading]);

  if (isError) {
    return (
      <div className={'download-error-message'}>
        <span>{errorMessage}</span>
      </div>
    );
  }
  return (
    <div className={'download-spinner'}>
      <LoadingSpinner status={isLoading} name={'Download-Page'} />
    </div>
  );
};
